import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SessionTimeoutComponent } from '../shared/components/session-timeout/session-timeout.component';
import { PsqServiceService } from './commonService/psq-service.service';
import { AuthService } from '@auth0/auth0-angular';
import { CommonService } from '../shared/common/common.service';


@Injectable({
  providedIn: 'root'
})
export class IdleService {

  private readonly WARNING_BUFFER_MS = 2 * 60 * 1000;

  private getIdleTime(): number {
    const storedTime = localStorage.getItem('auth0_expires_in_ms')
    const tokenDurationMs = storedTime ? parseInt(storedTime, 10) : (8 * 60 * 1000);
    return Math.max(tokenDurationMs - this.WARNING_BUFFER_MS, 60 * 1000);
  }

  private idleTimer: any;
  private popupOpened = false;
  private isWatching = false;

  private activityEvents = [
    'mousemove',
    'mousedown',
    'click',
    'scroll',
    'keydown',
    'touchstart'
  ];

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private readonly psqService: PsqServiceService,
    private readonly auth: AuthService,
    private readonly commonService: CommonService
  ) { }

  startWatching(): void {
    if (this.isWatching) {
      return;
    }
    this.isWatching = true;
    this.resetIdleTimer();

    this.activityEvents.forEach(event => {
      window.addEventListener(event, this.handleActivity);
    });
  }

  stopWatching(): void {
    if (!this.isWatching) {
      return; // Not watching, nothing to stop
    }
    this.isWatching = false;
    clearTimeout(this.idleTimer);
    this.activityEvents.forEach(event => {
      window.removeEventListener(event, this.handleActivity);
    });
  }

  private handleActivity = (): void => {

    if (this.popupOpened) {
      return;
    }

    this.resetIdleTimer();
  };

  private resetIdleTimer(): void {

    clearTimeout(this.idleTimer);

    this.idleTimer = setTimeout(() => {
      this.openTimeoutPopup();
    }, this.getIdleTime());
  }

  private openTimeoutPopup(): void {

    if (this.popupOpened) {
      return;
    }

    this.popupOpened = true;

    const dialogRef = this.dialog.open(SessionTimeoutComponent, {
      width: '500px',
      disableClose: true,
      panelClass: 'session-timeout-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {

      this.popupOpened = false;

      if (result === 'continue') {

        this.resetIdleTimer();

      } else {

        this.logout();
      }
    });
  }

  logout(): void {

    // localStorage.clear();
    // sessionStorage.clear();
    // this.router.navigate(['/']);


    this.stopWatching();
    this.psqService.clearStoredData();
    this.auth.logout();
    this.commonService.triggerLogoutTab();
  }
}


